import API from '../../../../../services/api';

export const getTickets = async (tab, entityId) => {
    return API.post('/tickets/get-pending', {tab, entityId}).then((res) => res.data);
};

export const assignTicket = async (ticketId, presupuestoId) => {
    return API.post('/tickets/assign', { ticketId, presupuestoId }).then(
        (res) => res.data
    );
};

export const unassignTicket = async (ticketId) => {
    return API.post('/tickets/unassign', { ticketId }).then((res) => res.data);
};

export const getTicketsCount = async () => {
    return API.get('/tickets/get-count').then((res) => res.data);
};

export const changeTicketState = async (data) => {
    return API.post('/tickets/change-state', data).then((res) => res.data);
}
